import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductInfo extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      descriptionAnchor: '.js-descriptionAnchor',
    };

    this.dom = {
      $component: component,
      $descriptionAnchor: this.$get(this.refs.descriptionAnchor),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    this.setClickWithElement(dom.$descriptionAnchor, this.scrollToSection);
  }

  scrollToSection(link) {
    const id = link.getAttribute('href');
    const section = document.querySelector(id);
    if (!section) return;

    const offsetTop = section.getBoundingClientRect().top;
    window.scrollBy({
      top: offsetTop - 100,
      left: 0,
      behavior: 'smooth',
    });
  }
}
